<template>
  <component :is="component"></component>
</template>
<script>
import Func8Contatos from '@/views/8/Func8Contatos.vue'

export default {
  name: 'Func8',
  data () {
    return {
      component: Func8Contatos
    }
  }
}
</script>
